class ExpressAddressPanelController {

    onSetEntryMode(mode) {
        this.addressEntryMode = mode;
    }
}

const expressAddressPanelControllerComponentDefinition = {
    controller: [ExpressAddressPanelController],
    template: require('./express-address-panel.component.html').trim(),
};

module.exports = {
    ExpressAddressPanelController,
    expressAddressPanelControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/express/express-address-panel.component.js